import { Button, Grid, Typography, Box, Hidden, IconButton, FormControl
    , InputLabel, Select } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as terapiaPlanService from "../../services/terapiaPlanService";
import * as personaService from "../../services/personaService";
import { obtenerPerfil } from "../../services/usuarioService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { setValue } from '../../redux/therapyPlanTherapistSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Navegabilidad de los planes de terapia del terapeuta: ve solo los planes de
// sus propias terapias, no todas. El unico filtro es el participante, y la
// lista sale de las propias terapias del terapeuta, asi que no se escriben
// nombres que no le corresponden.
//
// El terapeuta es el usuario logueado, igual que en la navegabilidad de
// sesiones: su persona sale de su perfil.
const Index = () => {
const { isReadOnly } = useMantenimiento(["terapiaPlan", "terapiaPlanTerapeuta"]);
    const filters = useSelector((state) => state.therapyPlanTherapistSearch.filters);
    const accesos = useSelector((state) => state.seguridad?.accesos || []);

    const [idTerapeuta, setIdTerapeuta] = useState(0);
    const [nombreTerapeuta, setNombreTerapeuta] = useState("");
    const [esTerapeuta, setEsTerapeuta] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    // Participantes de sus terapias, para el filtro.
    const [listParticipantes, setListParticipantes] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false);
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); };
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    // El listado son las terapias activas del terapeuta: las que tienen plan
    // se abren para editarlo y las que no, para crear el primero. La vista
    // resumen ya deja fuera las terapias anuladas.
    const fetchResults = async (idTerapeuta, member) => {
        if (!idTerapeuta || idTerapeuta <= 0) return;

        setCargando(true);

        await terapiaPlanService.getsTerapiaPlanResumenView({
                idFilial: 0,
                member: member == null ? "" : member,
                therapist: "",
                idEstadoVigencia: 0,
                idEstado: 0,
                idTerapeuta: idTerapeuta,
            })
            .then((data) => {
                setResults(data || []);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    }

    // El terapeuta de esta pantalla es el usuario logueado: su persona sale
    // de su perfil. Solo los terapeutas (idTipoPersona = 25) ven sus planes,
    // igual que en la navegabilidad de sesiones.
    const resolverTerapeuta = async () => {
        const perfil = await obtenerPerfil().catch(() => null);
        const id = perfil?.idPersona || 0;

        setIdTerapeuta(id);
        setNombreTerapeuta(perfil?.nombres || "");

        let terapeuta = false;
        if (id > 0) {
            const tipo = await personaService.getPersonaResumenBasicoById(id).catch(() => null);
            if (tipo === 25 || accesos.includes("terapiaPlanTerapeuta.ver") || accesos.includes("sesionTerapeuta.ver")) terapeuta = true;
        }
        setEsTerapeuta(terapeuta);

        if (!terapeuta) {
            setCargando(false);
            return;
        }

        // Se cargan todas sus terapias y de ahi sale la lista de participantes
        // para el filtro. Sin filtro: es el listado completo del terapeuta.
        const data = await terapiaPlanService.getsTerapiaPlanResumenView({
                idFilial: 0,
                member: "",
                therapist: "",
                idEstadoVigencia: 0,
                idEstado: 0,
                idTerapeuta: id,
            })
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        setResults(data || []);
        setCargando(false);

        const participantes = Array.from(new Set(
            (data || [])
                .map((row) => row.participante)
                .filter((p) => p != null && p !== "")
        )).sort();

        setListParticipantes(participantes);
    }

    useEffect(() => {
        resolverTerapeuta();
    }, []);

    const annul = async () => {
        await terapiaPlanService.annulTerapiaPlan(selectId)
            .catch((err) => {
                console.log("Err: ", err);
            });
        fetchResults(idTerapeuta, filters.member);
    }
    const active = async () => {
        await terapiaPlanService.activeTerapiaPlan(selectId)
            .catch((err) => {
                console.log("Err: ", err);
            });
        fetchResults(idTerapeuta, filters.member);
    }

    const columns = [
        { field: 'idTerapiaPlan', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'codigoFilial', headerName: 'Filial', width: 70, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 180, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/therapyplanterapist/edit/'
                    + (cellValues.row.idTerapiaPlan == null ? 0 : cellValues.row.idTerapiaPlan)
                    + '/' + cellValues.row.idTerapia}
                    style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'fechaInicio', headerName: 'Inicio', width: 110, sortable: false, headerAlign: 'center', align: 'center'
            , valueFormatter: (value) => (value ? moment(value).format('DD/MM/YYYY') : "") },
        { field: 'fechaFin', headerName: 'Fin', width: 110, sortable: false, headerAlign: 'center', align: 'center'
            , valueFormatter: (value) => (value ? moment(value).format('DD/MM/YYYY') : "") },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                // Sin plan no hay nada que anular ni activar: la terapia
                // aparece para crearle el primero.
                return <IconButton aria-label="anular" size='small' style={{ height: 10 }} align={"center"}
                    disabled={cellValues.row.idTerapiaPlan == null}
                    onClick={() => {
                        setSelectId(cellValues.row.idTerapiaPlan);
                        setSelectState(cellValues.row.estado);
                        setOpenDialogAnnulActive(true);
                    }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {nombreTerapeuta || (esTerapeuta === false ? "No es un terapeuta" : "Cargando...")}
                    </Typography>
                </Grid>
                {!esTerapeuta && idTerapeuta > 0 && (
                    <Grid item xs={12}>
                        <Typography variant="body1" color="warning.main" sx={{ pt: 2 }}>
                            Este usuario no está registrado como terapeuta. Solo los terapeutas pueden ver sus planes de terapia.
                        </Typography>
                    </Grid>
                )}
                {esTerapeuta && (<>
                <Grid item xs={12} sm={12}>
                    <Grid container item xs={12} sm={12} spacing={1}>
                        <Grid item xs={12} sm={8} md={4}>
                            <FormControl fullWidth size="small">
                                {/* El select es nativo y chico: la etiqueta
                                    tiene que ir encogida y del mismo tamano que
                                    el control, si no se monta sobre el texto. */}
                                <InputLabel htmlFor="input-participante" shrink size="small">Participante</InputLabel>
                                <Select
                                    native
                                    label="Participante"
                                    value={filters.member}
                                    onChange={(event) => {
                                        dispatch(setValue({ name: "member", value: event.target.value }))
                                        fetchResults(idTerapeuta, event.target.value);
                                    }}
                                    inputProps={{
                                        name: 'member',
                                        id: 'input-participante',
                                    }}
                                    size="small"
                                >
                                    <option key={0} value={0}>{"(Todos)"}</option>
                                    {listParticipantes.map((row) => (
                                        <option key={row} value={row}>{row}</option>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                            <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                fetchResults(idTerapeuta, filters.member)
                            }}>
                                {<Hidden smDown></Hidden>}
                                <IconSearch />
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                        <DataGridBase
                            rows={results}
                            columns={columns}
                            loading={cargando}
                            toolbarButtons={[
                                {
                                    text: "Nuevo",
                                    icon: <IconPersonAdd />,
                                    disabled: isReadOnly,
                                    onClick: () => navigate("/therapyplanterapist/edit/0")
                                }
                            ]}
                        />
                    </Box>
                </Grid>
                </>)}
                <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active}
                    setNo={() => { return }}
                    titulo={(selectState == "A" ? "Anular" : "Activar") + " Plan de Terapia"}
                    texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el plan de terapia?"} >
                </DialogYesNo>
            </Grid>
        </div>
    )
}
export default Index
